///////////////////////////////////////////////////////////////////////////////
// форматирование вывода
///////////////////////////////////////////////////////////////////////////////
import Helper from '../helper/helper'
import store from '../store'
const formaterPlugin = {
	//=========================================================================
	// установка плагина - обязательная функция
	//=========================================================================
	install(Vue, options) {
		//---------------------------------------------------------------------
		// mixin'ы
		//---------------------------------------------------------------------
		Vue.mixin({
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// этоти методы будут доступны из любого компонента
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			methods: {
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// делает у строки самый первый символ заглавным
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				formater_capitalizeFirstChar(string) {
					if (!string || string === '') return string
					return string.charAt(0).toUpperCase() + string.slice(1)
				},
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// форматирование даты в виде строки:
				// d - день с ведущим нулем
				// m - месяц с ведущим нулем
				// y - год без тысячилетия
				// Y - полный год
				// H - час с ведущим нулем
				// M - минута с ведущим нулем
				// S - секунда с ведущим нулем
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				formater_StrDateFormat(date, format = 'd.m.y H:M:S') {
					// проверка входного параметра: "2017-03-01 23:59:59"
					if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(date))
					{
						// может быть задана просто дата: "2017-03-01"
						if (/^\d{4}-\d{2}-\d{2}$/.test(date))
						{
							// это просто дата - дополним нулями
							date = date + ' 00:00:00'
						}
						// ни то, и ни другое
						else return date
					}

					// получим параметры
					let _parts = date.split(/\s/)
					let _date = _parts[0].split('-')
					let _time = _parts[1].split(':')

					// возвращаем результат
					return format
						.replace('d', _date[2])
						.replace('m', _date[1])
						.replace('Y', _date[0])
						.replace('y', _date[0].substr(2, 2))
						.replace('H', _time[0])
						.replace('M', _time[1])
						.replace('S', _time[2])
				},
				formater_StrDateOnly(date) {
					return this.formater_StrDateFormat(date, 'd.m.Y')
				},
				formater_StrDateHM(date) {
					return this.formater_StrDateFormat(date, 'd.m.y H:M')
				},
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// конвертирует дату в виде строки в объект Date
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				formater_StrDate2Date(date) {
					// проверка входного параметра: "2017-03-01"
					if (/^\d{4}-\d{2}-\d{2}$/.test(date)) date = date + ' 00:00:00'

					// проверка входного параметра: "2017-03-01 23:59:59"
					if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(date)) return null

					// получим параметры
					let _parts = date.split(/\s/)
					let _date = _parts[0].split('-')
					let _time = _parts[1].split(':')

					// возвращаем результат
					return new Date(
						parseInt(_date[0]),
						parseInt(_date[1]) - 1,
						parseInt(_date[2]),
						parseInt(_time[0]),
						parseInt(_time[1]),
						parseInt(_time[2])
					)
				},
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// конвертирует дату в виде форматированной строки в объект Date
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				formater_FormatedStrDate2Date(date, format) {
					// здесь будет строковая дата
					let _str = date

					// производим разбор значения если данные пришли не в нужном формате
					if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(date) && !/^\d{4}-\d{2}-\d{2}$/.test(date))
					{
						// определим разделитель - и в текстовом виде и для RegExp
						let _delimeter = ''
						let _expDelimeter = null
						if (format.indexOf('.') > 0)
						{
							_delimeter = '.'
							_expDelimeter = '\\.'
						}
						else if (format.indexOf('-') > 0)
						{
							_delimeter = '-'
							_expDelimeter = '-'
						}
						else if (format.indexOf('/') > 0)
						{
							_delimeter = '/'
							_expDelimeter = '\\/'
						}
						// формируем RegExp на основе заданного формата
						let _formatParts = format.split(_delimeter)
						let _exp = ''
						let _index = {}
						// обрабатываем каждую часть формата
						_formatParts.forEach((_key, _idx) => {
							if (_exp) _exp += _expDelimeter

							if (_key === 'd' || _key === 'm' || _key === 'y') _exp += '(\\d{2})'
							else if (_key === 'Y') _exp += '(\\d{4})'

							_index[_key] = _idx + 1
						})

						// разбиваем дату по частям
						let _match = null
						try {
							let _reg = new RegExp(_exp)
							_match = date.match(_reg)
							if (!_match) return null
						}
						catch (e) {
							return null
						}

						// проверка обязательных компонентов
						if (!_index['d'] || !_index['m']) return null
						if (!_index['Y'] && !_index['y']) return null

						// собираем в итоге дату в нужном нам формате
						_str = ''
						// год
						if (_index['Y']) _str += _match[_index['Y']]
						if (_index['y']) _str += String(1900 + _match[_index['y']])
						// разделитель
						if (_str) _str += '-'
						// месяц
						if (_index['m']) _str += _match[_index['m']]
						// разделитель
						if (_str) _str += '-'
						// день
						if (_index['d']) _str += _match[_index['d']]
					}

					// проверка входного параметра: "2017-03-01"
					if (/^\d{4}-\d{2}-\d{2}$/.test(_str)) _str = _str + ' 00:00:00'

					// проверка входного параметра: "2017-03-01 23:59:59"
					if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_str)) return null

					// получим параметры
					let _parts = _str.split(/\s/)
					let _date = _parts[0].split('-')
					let _time = _parts[1].split(':')

					// возвращаем результат
					return new Date(
						parseInt(_date[0]),
						parseInt(_date[1]) - 1,
						parseInt(_date[2]),
						parseInt(_time[0]),
						parseInt(_time[1]),
						parseInt(_time[2])
					)
				},
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// конвертирует объект Date в строку вида "yyyy-mm-dd"
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				formater_Date2StrDate(date, withTime = false) {
					if (!date) return date

					// проверка входного параметра
					if (typeof date === 'string')
					{
						let _dt = this.formater_StrDate2Date(date)
						if (_dt === null) return date
						date = _dt
					}

					let year = date.getFullYear()
					let month = date.getMonth() + 1
					let day = date.getDate()
					let hour = date.getHours()
					let min = date.getMinutes()
					let sec = date.getSeconds()

					return year + '-' +
							(month < 10 ? '0' : '') + month + '-' +
							(day < 10 ? '0' : '') + day +
							(withTime !== true ? '' : ' ' +
								(hour < 10 ? '0' : '') + hour + ':' +
								(min < 10 ? '0' : '') + min + ':' +
								(sec < 10 ? '0' : '') + sec)
				},
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// конвертирует объект Date в строку вида "yyyy-mm-dd HH:MM:SS"
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				formater_Date2StrDateTime(date) {
					// проверка входного параметра
					if (typeof date !== 'object') return date

					// возвращаем результат
					return date.toISOString().replace('T', ' ').substr(0, 19)
				},
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// конвертирует объект Date в строку вида "yyyy-mm-dd HH:MM:SS"
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				formater_Date2StrDateTimeAsIs(date) {
					// проверка входного параметра
					if (typeof date !== 'object') return date

					let year = date.getFullYear()
					let month = date.getMonth() + 1
					let day = date.getDate()
					let hour = date.getHours()
					let min = date.getMinutes()
					let sec = date.getSeconds()

					// возвращаем результат
					return year + '-' +
							(month < 10 ? '0' : '') + month + '-' +
							(day < 10 ? '0' : '') + day + ' ' +
							(hour < 10 ? '0' : '') + hour + ':' +
							(min < 10 ? '0' : '') + min + ':' +
							(sec < 10 ? '0' : '') + sec
				},
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// получает объект Date
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				formater_ParseToDate(date) {
					let ms = Date.parse(date)
					if (isNaN(ms)) return null
					let dt = new Date()
					dt.setTime(ms)
					return dt
				},
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// форматирование денег
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				formater_FormatMoney(money) {
					return Helper.FormatMoney2(money, store.state.user_type === 'admin' ? -1 : 2)
				},
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// форматирование числа
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				formater_StrToInt(str, ifNan = null) {
					let ans = parseInt(str, 10)
					if (isNaN(ans)) return ifNan
					return ans
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		})
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
export default formaterPlugin
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/plugins/formater.js